import { Layout, Text } from '@loadsmart/miranda-react'

export type InformationProps = {
  locationInfo: string
  dateInfo?: string
  facilityName?: string
  reserveSpace?: boolean
}

export function Information({
  locationInfo,
  dateInfo,
  facilityName,
  reserveSpace = false,
}: InformationProps) {
  // non-breaking space keeps the element with vertical space when dateInfo is empty
  const nbspCharacter = '\u00A0'
  const dateInfoWithReserveSpace = dateInfo || (reserveSpace ? nbspCharacter : undefined)

  return (
    <Layout.Stack gap="spacing-1">
      {facilityName && (
        <Text variant="body-sm" color="color-text-secondary">
          {facilityName}
        </Text>
      )}
      <Text variant="body-md-bold" color="color-text-primary">
        {locationInfo}
      </Text>
      {dateInfoWithReserveSpace && (
        <Text variant="body-sm" color="color-text-tertiary">
          {dateInfoWithReserveSpace}
        </Text>
      )}
    </Layout.Stack>
  )
}
